const settings = {
  // BACKEND_URL: 'https://testlmsapi.analytixlabs.co.in',
  // BACKEND_URL: 'http://139.59.70.192:4000',
  // BACKEND_URL: 'http://localhost:4000',
  BACKEND_URL: 'https://api-lms.analytixlabs.co.in',
  // IBM_BACKEND_URL: "https://courses.uofindia.skillsnetwork.site",
  // FRONTEND_URL: "https://lms.analytixlabs.co.in/#/login",
  // FRONTEND_API_URL: 'https://api.analytixlabs.co.in',
  FRONTEND_API_URL: 'https://devapi.analytixlabs.co.in',
  FRONTEND_URL: 'https://dev.analytixlabs.co.in/',
  // FRONTEND_URL: 'https://www.analytixlabs.co.in/',
  // DOMAIN: {domain: '.analytixlabs.co.in'},
  DOMAIN: {path: '/'},
}

export default settings
